import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import { DemographicsTextCard } from "~/components/DemographicsTextCard";
import { UsersFourIcon } from "@phosphor-icons/react";

import * as styles from "../../styles";

export const TotalPopulation = () => {
  const { t } = useTranslation("localDemographics");
  const {
    demographicsState: { population_total: populationTotal },
  } = useDemographics();

  const dataset = useMemo(
    () => populationTotal?.variables[0],
    [populationTotal?.variables]
  );

  const chartOptions = useMemo(
    () => ({
      options: {
        title: t("data.population.graphs.totalPopulation.title"),
        values: [
          {
            variable: dataset?.variable || "",
            value: `${new Intl.NumberFormat("en-EN").format(Math.round(dataset?.value || 0))}`,
            label: t("data.population.graphs.totalPopulation.title"),
            icon: UsersFourIcon,
          },
        ],
      },
    }),
    [dataset]
  );

  return (
    <div className={styles.cardContainer}>
      <DemographicsTextCard {...chartOptions} />
    </div>
  );
};
